import { uploadCaseFilesByFileNames } from "@/core/app/slices/clinical/clinicalThunkApi"
import {
  fetchFilesList,
  downloadPhotoJSON,
} from "@/core/app/slices/records/photograph"
import { caseManagement, wasmModule } from "@/gluelayer"
import { setCurLeftPage } from "@/UDTreat/udTreatSlice"
import { createAsyncThunk } from "@reduxjs/toolkit"

interface Params {
  patientId: string
  caseId: string
  refinementIndex?: number
}

export const fetchPhotosInModelCheck = createAsyncThunk(
  "photo/fetchAndHandlePhotos",
  async (params: Params, { dispatch }) => {
    const { patientId, caseId, refinementIndex } = params

    const ret: any = await dispatch(fetchFilesList({ patientId, caseId }))
    const retData = ret.payload.data

    if (retData.response_code !== 200) {
      console.warn("Fetch file list failed::", retData)
      return
    }

    const isTypeXJson = (str: string) => {
      const regex = new RegExp(`type${refinementIndex || ""}.json`)
      return regex.test(str)
    }

    const typeFileInfo = retData.result.filter(
      (item: any) =>
        isTypeXJson(item.file_name) &&
        item.attachment_type === "photopositiontype",
    )

    if (typeFileInfo.length > 0) {
      const jsonRet: any = await dispatch(
        downloadPhotoJSON({
          caseId,
          patientId,
          refinementIndex: refinementIndex ?? 0,
        }),
      )

      if (!Object.hasOwn(jsonRet, "error")) {
        const jsonData = jsonRet.payload.data

        const PhotoThumbMap = jsonData.thumbs ? { ...jsonData.thumbs } : {}

        if (Object.keys(PhotoThumbMap).length === 0) {
          console.warn("No photo thumbs found in the JSON data.")
          return
        }

        dispatch(setCurLeftPage("records"))
      }
    }
  },
)

export const uploadModelCheckZips = createAsyncThunk(
  "modelcheck/uploadModelCheckZips",
  async (params: Params, { dispatch }) => {
    const { patientId, caseId } = params

    const isChangedFiles = [
      "Setting Data0",
      "Setting Data1",
      "Setting Data2",
      "Setting Data10",
    ]

    const needUploadZips = []
    isChangedFiles.forEach((fileName) => {
      const isChanged = wasmModule.statusController.WasFolderChanged(fileName)
      console.log(` Model Check - ${fileName} is changed: `, isChanged)
      if (isChanged) {
        //把"Setting Data"改成对应的zip文件名,类似"bulk0.zip"
        const prefox = fileName.replace("Setting Data", "bulk") + ".zip"
        needUploadZips.push(prefox)
      }
    })

    if (needUploadZips.length === 0) {
      console.log("No Model Check files need to upload.")
      caseManagement.setTxDataChanged(false)
      return
    }

    dispatch(
      uploadCaseFilesByFileNames({
        patientId,
        caseId,
        fileNames: needUploadZips,
      }),
    ).then(() => {
      console.log("finish auto model check upload zips :", needUploadZips)
      caseManagement.setTxDataChanged(false)
    })
  },
)
